// Version picker inside product add-on cards (product_bundle_advanced).
// The checkbox in each card is what gets added to the cart, so a new version rewrites
// its value and prices, swaps the card image and ticks it. Delegated on document.
(() => {
  if (window.__bundleAddonSelect) return;
  window.__bundleAddonSelect = true;

  const apply = (select, tick) => {
    const card = select.closest('.product-bundle__info');
    const option = select.selectedOptions[0];
    if (!card || !option) return;

    const input = card.querySelector('input[name="bundles"]');
    if (input) {
      input.value = option.value;
      input.setAttribute('data-price', option.dataset.price);
      input.setAttribute('data-original-price', option.dataset.originalPrice);
      if (tick && !input.disabled && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const price = card.querySelector('[data-addon-price]');
    const original = card.querySelector('[data-addon-original]');
    if (original) {
      original.textContent = option.dataset.originalPriceText;
      if (price) price.textContent = option.dataset.priceText;
    } else if (price) {
      price.textContent = option.dataset.originalPriceText;
    }

    const img = card.querySelector('picture img');
    if (img && option.dataset.img) {
      img.removeAttribute('srcset');
      img.src = option.dataset.img;
    }

    // Keep the custom button + list in step (also covers changes not made through the list).
    const label = card.querySelector('.styled-select__value');
    if (label) label.textContent = option.textContent.trim();
    card.querySelectorAll('.styled-select__option').forEach((li) => {
      li.setAttribute('aria-selected', String(li.getAttribute('data-value') === option.value));
    });
  };

  // Offers that add more of the product being viewed (Buy 2 / Buy 3) are alternatives: ticking one unticks the others.
  document.addEventListener('change', (e) => {
    const box = e.target;
    if (!box.matches('input[name="bundles"][data-addon-same-product]') || !box.checked) return;
    const scope = box.closest('[id^="ProductBundleAdvanced-"]') || document;
    scope.querySelectorAll('input[name="bundles"][data-addon-same-product]').forEach((other) => {
      if (other !== box && other.checked) {
        other.checked = false;
        other.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  document.addEventListener('change', (e) => {
    if (!e.target.matches('select[data-addon-native]')) return;
    e.target.dataset.touched = 'true';
    apply(e.target, true);
  });

  // When the main product's variant changes (e.g. Nebula Black), pre-select the same version
  // on an add-on of the same product, unless the shopper has already picked one there.
  document.addEventListener('variant:change', (e) => {
    const variant = e.detail && e.detail.variant;
    if (!variant) return;
    document.querySelectorAll('select[data-addon-native]').forEach((select) => {
      if (select.dataset.touched) return;
      const match = select.querySelector(`option[value="${variant.id}"]`);
      if (match && select.value !== match.value) {
        select.value = match.value;
        apply(select, false);
      }
    });
  }, true);
})();
